import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-circle-slider",
  "use": "default-circle-slider-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 42\" id=\"default-circle-slider\"><path d=\"M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21zm0-3c-9.941 0-18-8.059-18-18S11.059 3 21 3s18 8.059 18 18-8.059 18-18 18z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol